import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'WEBHOOK_TYPES',
    identifier: 'type',
    itemActionName: 'WEBHOOK_TYPE',
});
